<template>
    <div class="solicitacoes-depara">
        <container-card id="filtroSolicitacoes" icon="fa-filter" title="Filtrar solicitações.">
            <!-- MODAL DE DETALHES - VER MAIS -->
            <b-modal
                ref="modalDetalhesaVerMais"
                size="lg"
                id="modal-detalhes-vermais"
                title="Detalhes da solicitação"
                tabindex="-1"
                >
                <div class="solicitacoes-depara">
                    <div class="status-modal">
                        <el-tooltip v-if="modelVerMais.status === 'Em aberto'" class="item" effect="dark" content="Status: Em aberto" placement="top-start">
                            <i class="fas fa-circle text-primary"></i>
                        </el-tooltip>
                        <el-tooltip v-if="modelVerMais.status === 'Aprovada'" class="item" effect="dark" content="Status: Aprovado" placement="top-start">
                            <i class="fas fa-circle text-success"></i>
                        </el-tooltip>
                        <el-tooltip v-if="modelVerMais.status === 'Rejeitada'" class="item" effect="dark" content="Status: Rejeitado" placement="top-start">
                            <i class="fas fa-circle text-warning"></i>
                        </el-tooltip>
                        <el-tooltip v-if="modelVerMais.status === 'Cancelada'" class="item" effect="dark" content="Status: Cancelado" placement="top-start">
                            <i class="fas fa-circle text-danger"></i>
                        </el-tooltip>
                    </div><br>
                    <div class="detalhes detalhes-modal">
                        <p><b>Grupo:</b> {{ modelVerMais.customer }}</p>
                        <p><b>De:</b> {{ modelVerMais.de }}</p>
                        <p><b>Para:</b> {{ modelVerMais.para }}</p>
                        <p><b>Registro do franqueado:</b> {{ modelVerMais.registroDoFranqueado }}</p>
                    </div>
                    <div class="detalhes detalhes-modal">
                        <p><b>Data:</b> {{ modelVerMais.dataDaSolicitacao }}</p>
                        <p>
                            <b>Status:</b>
                            {{ modelVerMais.status }}
                        </p>
                    </div><br>

                    <div class="detalhes detalhes-modal info-nota" v-if="modelVerMais.notas && modelVerMais.notas.length">
                        <h4>Informações de solicitação {{ modelVerMais.status }}</h4>
                        <p><b>Usuário:</b> {{ modelVerMais.notas[0].user }}</p>
                        <p><b>Data {{ modelVerMais.status }}:</b> {{ modelVerMais.notas[0].data }}</p>
                        <p><b>Descrição/Justificativa:</b> {{ modelVerMais.notas[0].value }}</p>
                    </div>
                </div>

                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                    </div>
                </template>
            </b-modal>

            <!-- MODAL DE REJEITAR SOLICITAÇÃO -->
            <b-modal
                ref="modalRejeitar"
                size="lg"
                id="modal-rejeitar"
                title="Rejeitar solicitação"
                tabindex="-1"
                >
                
                <div class="rejeitar-detalhes">
                    <div class="solicitacoes-depara" v-for="(detalhe,i) in solicitacoesSelecionadas" :key="i">
                        <div class="detalhes detalhes-modal">
                            <p><b>Grupo:</b> {{ detalhe.customer }}</p>
                            <p><b>De:</b> {{ detalhe.de }}</p>
                            <p><b>Para:</b> {{ detalhe.para }}</p>
                            <p><b>Registro do franqueado:</b> {{ detalhe.registroDoFranqueado }}</p>
                            <p><b>Data:</b> {{ detalhe.dataDaSolicitacao }}</p>
                            <p>
                                <b>Status:</b>
                                {{ detalhe.status }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="solicitacoes-depara-total">
                    <p><b>Total de solicitações:</b> {{ solicitacoesSelecionadas.length }}</p>
                </div>
                <el-form class="rejeitar-form form-login" :model="rejeitarFormModel" ref="rejeitarForm">
                    <el-form-item
                        label="Justificativa"
                        prop="justificativa"
                        :rules="[{ required: true, message: 'É necessário criar uma justificativa'}]"
                    >
                        <el-input type="textarea" v-model="rejeitarFormModel.justificativa"></el-input>
                    </el-form-item>
                </el-form>
                 
                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                        <el-button type="primary" size="small" @click="envioRejeitar" :loading="loadRejeitar">Rejeitar solicitações</el-button>
                    </div>
                </template>

            </b-modal>

            <el-button round class="aprove-button aprove-button-rejeitar"
                v-show="solicitacoesSelecionadas.length > 0 && mostrarBtns"
                @click="rejeitarSolicitacao"
                v-b-popover.hover.top="'Rejeitar solicitação.'"
                v-b-modal.modal-rejeitar>
                <i class="fas fa-times"></i>
                Rejeitar
            </el-button>

            <el-button round class="aprove-button aprove-button-aprovar"
                v-show="solicitacoesSelecionadas.length > 0 && mostrarBtns"
                @click="aprovarSolicitacao"
                v-b-popover.hover.top="'Aprovar solicitação.'">
                <i class="fas fa-check"></i>
                Aprovar
            </el-button>

            <el-form v-loading="loadingSolicitacoes" :model="model" ref="formSolicitacoes" size="mini" label-position="top">
                <b-card>
                    <b-form-row class="mb-2">
                        <div class="col-lg-5 col-md-6">
                            <b-form-row class="mb-0">
                                <div class="col-lg-12 col-md-12">
                                    <el-form-item label="Status de Solicitação" prop="Tipo">
                                        <el-select class="w-100" size="small" clearable v-model="model.Status" placeholder="selecione">
                                        <el-option
                                            v-for="item in listas.status"
                                                :key="`tipos_${item.id}`"
                                                :label="item.label"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </b-form-row>
                        </div>
                        <div class="col-lg-7 col-md-6 cluster-input">
                            <el-form-item :label="`Grupo${model.clusterGrupoBool ? ' (Cluster)' : ''}:`" label-for="grupo" :prop="model.clusterGrupoBool ? 'ClustersGruposIds' : 'grupo'">
                                <div class="toogle-multiselect-cluster">
                                    <small class="label-toogle-cluster">{{ model.clusterGrupoBool ? 'Alterar para grupos' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                                    <el-switch v-b-popover.hover.top="'Alternar combo clusters/grupos.'"
                                                v-model="model.clusterGrupoBool"></el-switch>
                                </div>
                                <div v-show="model.clusterGrupoBool == false">
                                    <el-select class="w-100" size="small"  filterable clearable multiple v-model="model.Grupos" name="gruposSelect" placeholder="selecione">
                                        <el-option
                                        v-for="item in listas.grupos"
                                            :key="`grupo_${item.id}`"
                                            :label="item.label"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-show="model.clusterGrupoBool == true">
                                    <el-select class="w-100" size="small"  filterable clearable multiple v-model="model.ClustersGruposIds" name="gruposClusterSelect" placeholder="selecione">
                                        <el-option
                                        v-for="item in listas.cluster"
                                            :key="`cluster_${item.id}`"
                                            :label="item.label"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </div>
                    </b-form-row>
                    <div slot="footer">
                        <div class="float-left btn-pesquisar">
                            <b-button style="width:100px;" @click.prevent="pesquisarSolicitacoes" variant="primary" size="sm" class="mr-2">Pesquisar</b-button>
                            <b-button style="width:100px;" @click.prevent="limpar" size="sm" class="mr-2">Limpar</b-button>
                        </div>
                        <div class="float-right">
                            <div class="aviso" v-show="!mostrarBtns"><i class="el-icon-info"></i> Não é possível aprovar/rejeitar solicitações que já foram modificadas pelo painel.</div>
                        </div>
                    </div>
                </b-card>
            </el-form>
        </container-card>
        <container-card fixed id="tableSolicitacoes" icon="fa-th-list" title="Lista de Solicitações.">
            <b-card>
                <el-table
                    class="p-table solicitacoes"
                    ref="solicitacaoTable"
                    v-loading="tableOptions.load"
                    :data="tableOptions.data"
                    style="width: 100%"
                    stripe
                    border
                    @selection-change="handleSelectionChange"
                    size="mini">

                    <el-table-column
                    type="selection"
                    width="55">
                    </el-table-column>

                    <el-table-column
                        prop="customer"
                        label="Grupo"
                        align="left"
                        width="300">
                    </el-table-column>

                    <el-table-column
                        label="Detalhes">
                        <template slot-scope="scope" v-if="scope.row">
                            <div class="detalhes">
                                <p><b>De:</b> {{ scope.row.de }}</p>
                                <p><b>Para:</b> {{ scope.row.para }}</p>
                                <p><b>Registro do franqueado:</b> {{ scope.row.registroDoFranqueado }}</p>
                                <el-button class="ver-mais" round size="mini" v-b-modal.modal-detalhes-vermais @click="setModelVerMais(scope.row)">Ver mais</el-button>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="usuario"
                        label="Usuário"
                        width="100"
                        align="left">
                    </el-table-column>

                    <el-table-column
                        prop="dataDaSolicitacao"
                        label="Data solicitação"
                        align="left"
                        width="130">
                    </el-table-column>


                    <el-table-column
                        fixed="right"
                        label="Status"
                        width="70"
                        align="center">
                        <template slot-scope="scope" v-if="scope.row">
                            <el-tooltip v-if="scope.row.status === 'Em aberto'" class="item" effect="dark" content="Status: Em aberto" placement="top-start">
                                <i class="fas fa-circle text-primary"></i>
                            </el-tooltip>
                            <el-tooltip v-if="scope.row.status === 'Aprovada'" class="item" effect="dark" content="Status: Aprovado" placement="top-start">
                                <i class="fas fa-circle text-success"></i>
                            </el-tooltip>
                            <el-tooltip v-if="scope.row.status === 'Rejeitada'" class="item" effect="dark" content="Status: Rejeitado" placement="top-start">
                                <i class="fas fa-circle text-warning"></i>
                            </el-tooltip>
                            <el-tooltip v-if="scope.row.status === 'Cancelada'" class="item" effect="dark" content="Status: Cancelado" placement="top-start">
                                <i class="fas fa-circle text-danger"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                </el-table><br>
                <el-pagination
                    class="text-center"
                    background
                    layout="sizes, prev, pager, next"
                    @size-change="paginacaoSize"
                    @current-change="paginacaoCurrent"
                    :page-size="tableOptions.paginacao.pageSize"
                    :current-page.sync="tableOptions.paginacao.page"
                    :total="tableOptions.paginacao.total"
                    :page-sizes="[5, 10, 25, 50, 75, 100]">
                </el-pagination>
            </b-card>
        </container-card>
    </div>
</template>

<script>
import ContainerCard from '@/components/shared/ContainerCard'
import Select2 from '@/components/shared/Select2'
import Select2Multiple from '@/components/shared/Select2Multiple'


    const model = () => {
        return {
            Tipo: '',
            Grupos: '',
            ClustersGruposIds: [],
            clusterGrupoBool: false
        }
    }
    export default {
        components: {
            ContainerCard,
            Select2,
            Select2Multiple
        },
        data() {
            return {
                model: model(),
                modelVerMais: {},
                solicitacoesSelecionadas: [],
                rejeitarFormModel: {
                    justificativa: '',
                },
                loadRejeitar: false,
                loadingSolicitacoes: false,
                listas: {
                    status: [
                        { id:0, label: 'Em aberto'},
                        { id:1, label: 'Aprovado'},
                        { id:2, label: 'Rejeitado'},
                        { id:3, label: 'Cancelado'},
                    ],
                    grupos: [],
                    cluster: []
                },
                tableOptions: {
                    load: false,
                    data: [],
                    paginacao: {
                        page: 1,
                        pageSize: 25,
                        total: 10
                    }
                }
            }
        },
        methods: {
            pesquisarSolicitacoes() {
                this.listarSolicitacoes();
            },
            limpar() {
                this.model = model()
            },
            paginacaoCurrent(val){
                this.tableOptions.paginacao.page = val
                this.listarSolicitacoes();
            },
            paginacaoSize(val){
                this.tableOptions.paginacao.pageSize = val
                this.tableOptions.paginacao.page = 1
                this.listarSolicitacoes();
            },
            async listarSolicitacoes() {
                try {
                    this.tableOptions.load = true;

                    const response = await this.axios.get(this.$urls.SOLICITACOES_LISTAR, {
                        params: {
                            CustomerId: !this.model.clusterGrupoBool ? this.model.Grupos.join(',') : this.model.ClustersGruposIds.join(','),
                            Tipo: 0,
                            Status: this.model.Status,
                            page: this.tableOptions.paginacao.page,
                            pageSize: this.tableOptions.paginacao.pageSize
                        }
                    });

                    this.tableOptions.load = false
                    
                    if(response.status !== 200){
                        this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                        return;
                    }
                    
                    this.tableOptions.data = response.data.valores;
                    this.tableOptions.paginacao.page = response.data.page;
                    this.tableOptions.paginacao.total = response.data.total;
                } catch(err) {
                    this.$notify.error({
                        title: 'Erro interno',
                        message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                        position:'top-left'
                    });
                }finally {
                    this.tableOptions.load = false
                }
            },
            async getListas(optModel, route) {
                let response = await this.axios.get(route);

                if(response.status !== 200) {
                    return;
                }

                this.$data.listas[optModel] = response.data;
            },
            setModelVerMais(mdl) {
                this.modelVerMais = mdl
            },
            handleSelectionChange(val) {
                this.solicitacoesSelecionadas = val;

                console.log(this.solicitacoesSelecionadas)
            },
            rejeitarSolicitacao() {
                this.justificativa = ''
            },
            aprovarSolicitacao() {
                this.$confirm('Deseja aprovar todas as solicitações selecionadas?', 'Aprovar solicitações', {
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    type: 'Warning'
                }).then(() => {
                    this.aprovar()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Aprovação cancelada'
                    });          
                });
            },
            async aprovar() {
                try {
                    this.loadRejeitar = true
				    let request = await  this.axios.post(this.$urls.SOLICITACOES_APROVAR, this.solicitacoesSelecionadas.length ? this.solicitacoesSelecionadas.map(item => item._id) : []);
                    
                    if(request.status !== 200) {
                        this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                        return;
                    }

                    this.$notify({
                            title: 'Sucesso',
                            message: `Solicitações aprovadas!`,
                            position:'top-left',
                            type: 'success'
                    });
                    this.loadRejeitar = false;
                    this.listarSolicitacoes();
                } catch (error) {
                    this.$notify.error({
                        title: 'Ocorreu um erro no processo',
                        message: `Houve um erro ao tentar rejeitar solicitações`,
                        position:'top-left'
                    });
                }
            },
            async rejeitar() {
                try {
                    this.loadRejeitar = true
				    let request = await  this.axios.post(this.$urls.SOLICITACOES_REJEITAR, {
                        ids: this.solicitacoesSelecionadas.length ? this.solicitacoesSelecionadas.map(item => item._id) : [],
                        justificativa: this.rejeitarFormModel.justificativa 
                    });

                    if(request.status !== 200) {
                        this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                        return;
                    }

                    this.$notify({
                            title: 'Sucesso',
                            message: `Solicitações rejeitadas!`,
                            position:'top-left',
                            type: 'success'
                    });
                    this.loadRejeitar = false;
                    this.$refs['modalRejeitar'].hide()
                    this.listarSolicitacoes();
                } catch (error) {
                    this.$notify.error({
                        title: 'Ocorreu um erro no processo',
                        message: `Houve um erro ao tentar rejeitar solicitações`,
                        position:'top-left'
                    });
                }
            },
            envioRejeitar() {
                this.$refs['rejeitarForm'].validate((valid) => {
                    if (!valid) {
                        return;
                    } 

                    this.rejeitar()
                });
            }
        }, 
        computed: {
            mostrarBtns() {
                let obj = this.solicitacoesSelecionadas.find(item => item.status !== "Em aberto")
                return obj ? false : true
            }
        },
        mounted() {
            this.getListas('grupos', this.$urls.GRUPOS);
            this.getListas('cluster', this.$urls.CLUSTERS);
        }
    }
</script>

<style lang="scss">
.solicitacoes-depara {
    &-total {
        background: #d5edf3;
        border-radius: 4px;
        height: 28px;
        padding: 0px 10px 0px;
        text-align: right;
        margin-top: 7px;
    }
    .toogle-multiselect-cluster {
        position: absolute;
        top: -30px;
        right: 6px;
    }
    label.el-form-item__label {
        padding: 0 0 0 !important;
    }
    .detalhes {
        text-align:left;
        padding: 9px;
        position:Relative;
        p {
            margin: 0;
            padding: 0 65px 0px 10px;
            background: #efefef;
            border-radius: 17px;

            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 100%;
            &:nth-child(even) {
                background: #fff;
            }
            b {
                font-weight: 900;
                color: #4f7ce1;
                margin-right: 5px;
            }
        }
        .ver-mais {
            position: absolute;
            bottom: 9px;
            right: 5px;
            padding: 6px 11px;
        }
        &.info-nota {
            border: 1px solid #ccc;
            border-radius: 4px;
            padding: 20px;
            h4 {
                font-size: 17px;
            }
        }
    }
    .detalhes-modal p {
        overflow-wrap: break-word;
        overflow: inherit;
        white-space: inherit;
    }
    .status-modal {
        position: absolute;
        left: 30px;
        top: 10px;
    }
}
.rejeitar-detalhes {
    max-height: 340px;
    overflow: auto;
}
.aviso {
    color: #db7272;
    border: 1px solid #ccc;
    padding: 2px 30px;
    border-radius: 5px;
}
.el-table.solicitacoes {
    .el-table__row {
        td:nth-of-type(3) .cell {
            display: contents !important;
        }
    }
}
div button.aprove-button-rejeitar {
        background:#ff4d4d;
        border-color:#fa4444;

        right: 164px;
    }
div button.aprove-button-rejeitar:hover {
    background:#f54040;
    border-color:#e93030;
}
</style>